import {CSSProperties, useCSS, useColors} from '@pinecast/styles';

const animationName = {
  '0%': {transform: 'scale(0)'},
  '80%': {transform: 'scale(0)'},
  '100%': {transform: 'scale(0)'},
  '40%': {transform: 'scale(1)'},
};

const Spinner = ({
  style,
  type = 'default',
}: {
  style?: CSSProperties;
  type?: 'default' | 'focus' | 'subtle' | 'white';
}) => {
  const css = useCSS();
  const designColors = useColors();
  const backgroundColor =
    type === 'default'
      ? designColors.contentText
      : type === 'focus'
      ? designColors.headingBlue
      : type === 'subtle'
      ? designColors.contentBackground
      : '#fff';
  return (
    <div
      className={css({
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        ...style,
      })}
    >
      <i
        className={css({
          animationName,
          animationDuration: '1s',
          animationIterationCount: 'infinite',
          backgroundColor,
          borderRadius: '20px',
          height: '10px',
          margin: '0 2px',
          width: '10px',

          animationDelay: '0s',
        })}
      />
      <i
        className={css({
          animationName,
          animationDuration: '1s',
          animationIterationCount: 'infinite',
          backgroundColor,
          borderRadius: '20px',
          height: '10px',
          margin: '0 2px',
          width: '10px',

          animationDelay: '-0.66s',
        })}
      />
      <i
        className={css({
          animationName,
          animationDuration: '1s',
          animationIterationCount: 'infinite',
          backgroundColor,
          borderRadius: '20px',
          height: '10px',
          margin: '0 2px',
          width: '10px',

          animationDelay: '-0.33s',
        })}
      />
    </div>
  );
};

export default Spinner;
